import classes from './PropertyDetail.module.css';
import { Col, Container, Row } from 'react-bootstrap';
import parse from 'html-react-parser';
import moment from 'moment';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { AiFillHeart, AiOutlineHeart } from 'react-icons/ai';
import { BiTimeFive } from 'react-icons/bi';
import { BsShareFill } from 'react-icons/bs';
import { MdLocationOn, MdOutlineDateRange, MdReport } from 'react-icons/md';
import { useSelector } from 'react-redux';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { ReactSVG } from 'react-svg';
import { toast } from 'react-toastify';
import AverageRatesWithMarketTrends from '../../Component/AverageRatesWithMarketTrends';
import BankLoanBanner from '../../Component/BankLoanBanner';
import BannerImageAd from '../../Component/BannerImageAd';
import ClientManagerCard from '../../Component/ClientManagerCard';
import DetailPageHeroSection from '../../Component/DetailPageHeroSection';
import Footer from '../../Component/Footer';
import Header from '../../Component/Header';
import ListItemWithCheckMark from '../../Component/ListItemWithCheckMark';
import { Loader } from '../../Component/Loader';
import MortgageCalculator from '../../Component/MortgageCalculator';
import RenderBreadcrum from '../../Component/RenderBreadcrum';
import ShareModal from '../../Component/ShareModal/ShareModal';
import Tabs from '../../Component/Tabs';
import Tooltip from '../../Component/Tooltip';
import { restrictOnlyUserActions } from '../../Helper/restrictActions';
import { imageUrl } from '../../config/apiUrl';
import { propertiesData } from '../../constant/commonData';
import {
  Area,
  AreaIcon,
  Bath,
  building,
  Circle360Icon,
  Grounds,
  MapMarkerIcon,
  PhotoIcon,
  Rooms,
  StreetViewIcon,
  VideoIcon
} from '../../constant/imagePath';
import ReportListingModal from '../../modals/ReportListingModal';
import {
  useFavoriteEntityMutation,
  useGetPublicOkPropertyDetailQuery
} from '../../store/apiSlice/apiSlice';
import { m2ToFt2, usdToOther } from '../../utils/helpers';

const PropertyDetails = () => {
  const { allBanners } = useSelector((state) => state.commonReducer);
  let [searchParams] = useSearchParams();
  const adminToken = searchParams.get('token') || '';
  const navigate = useNavigate();
  const { t } = useTranslation('propertyDetail');
  const { user, isLogin } = useSelector((state) => state?.authReducer);
  const { selectedLanguage } = useSelector((state) => state?.languageReducer);
  const { areaUnit, currency } = useSelector((state) => state?.converterReducer);
  const slug = useParams()?.slug;
  const { data, isLoading, refetch } = useGetPublicOkPropertyDetailQuery({
    slug: `${slug}?token=${adminToken || ''}`
  });
  const __propertyType = data?.data?.propertyPurpose?.en?.toLowerCase() == 'buy' ? 'buy' : 'rent';
  const thisPageBanners = allBanners?.filter((b) => b.page === `${__propertyType}-detail`);
  const [reportShow, setReportShow] = useState('');
  const [isShareModalOpen, setIsShareModalOpen] = useState(false);
  const propertyData = data?.data;
  // console.log(propertyData, 'propertyData');

  const tabsData = [
    {
      icon: <ReactSVG src={PhotoIcon} size={20} />,
      // text: t('tabs.photos'),
      id: '1',
      value: 'Photos',
      tooltipText: t('tabs.photos')
    },
    {
      icon: <ReactSVG src={AreaIcon} size={20} />,
      // text: t('tabs.plans'),
      id: '2',
      value: 'Plans',
      tooltipText: t('tabs.plans')
    },
    {
      icon: <ReactSVG src={Circle360Icon} size={20} />,
      // text: t('tabs.360view'),
      id: '3',
      value: '360',
      disabled: !propertyData?.threeSixtyViewLink,
      tooltipText: t('tabs.360view')
    },
    {
      icon: <ReactSVG src={MapMarkerIcon} size={20} />,
      // text: t('tabs.location'),
      id: '4',
      value: 'Location',
      tooltipText: t('tabs.location')
    },
    {
      icon: <ReactSVG src={StreetViewIcon} size={20} />,
      // text: t('tabs.streetView'),
      id: '5',
      value: 'Street',
      tooltipText: t('tabs.streetView')
    },
    {
      icon: <ReactSVG src={VideoIcon} size={20} />,
      // text: t('tabs.video'),
      id: '6',
      value: 'Video',
      tooltipText: t('tabs.video')
    }
  ];
  const [tabValue, setTabValue] = useState(tabsData[0]);

  const [onFavorite, { isLoading: isFavoriting }] = useFavoriteEntityMutation();

  const isFavorite = propertyData?.favoriteBy?.includes(user?._id);

  const handleFavorite = async () => {
    if (isFavoriting) return;
    const res = await onFavorite({ id: propertyData?._id, type: 'property' });
    if (res?.data) {
      if (res?.data?.data?.favoriteBy?.includes(user?._id)) {
        toast.success(`${t('message.added')}`);
      } else {
        toast.success(`${t('message.removed')}`);
      }
      refetch();
    }
  };

  const handleAction = () => {
    const isAllowedActions = restrictOnlyUserActions(user?.role);
    if (!isLogin) {
      navigate('/login');
    } else if (isAllowedActions) {
      return true;
    }
  };
  return (
    <>
      <Header containerClass="" />

      {isLoading ? (
        <Loader className={classes?.loader} />
      ) : (
        <div className={classes.main}>
          <section className={classes.images}>
            {/* <p>abcsss</p> */}
            <DetailPageHeroSection
              plansPicture={propertyData?.planImages ?? []}
              images={propertyData?.images ?? []}
              text={tabValue?.value}
              videoLink={propertyData?.videoLink ?? ''}
              location={{
                lat: propertyData?.location?.coordinates?.[1],
                lng: propertyData?.location?.coordinates?.[0]
              }}
              threeSixtyImage={propertyData?.threeSixtyViewLink}
            />

            <div className={classes.socialIconsWrap1}>
              <div className={[classes.socialIcons1].join(' ')}>
                <BsShareFill onClick={() => setIsShareModalOpen(true)} fill="white" size={25} />
              </div>
              <div className={[classes.socialIcons1, classes.borderRight].join(' ')}>
                {isFavorite ? (
                  <AiFillHeart
                    onClick={() => {
                      if (!handleAction()) return;
                      handleFavorite();
                    }}
                    fill="var(--primary-clr)"
                    size={25}
                    className="c-p"
                  />
                ) : (
                  <AiOutlineHeart
                    onClick={() => {
                      if (!handleAction()) return;
                      handleFavorite();
                    }}
                    fill="white"
                    size={25}
                    className="c-p"
                  />
                )}
              </div>
              <div className={[classes.socialIcons1].join(' ')}>
                <MdReport
                  onClick={() => {
                    setReportShow(true);
                  }}
                  fill="white"
                  size={25}
                  className="c-p"
                />
              </div>
            </div>
          </section>
          <Container className={[classes.container].join(' ')}>
            <Row className={classes.gap}>
              <Col md={12}>
                <RenderBreadcrum data={propertyData} type="property" />
              </Col>
              <Col md={12} lg={9} className={classes.col1}>

                <div className={classes.detailWrap}>
                  <div className={classes.firstRowLeftCol}>
                    <div className={classes.priceRow}>
                      <div>
                        <div className={classes.price}>
                          <div className={classes.rowBetween}>
                            <div className={classes.perPrice}>
                              <p>{usdToOther({ amount: propertyData?.price, ...currency })}</p>
                              {propertyData?.propertyPurpose?.en == 'Rent' ? (
                                propertyData?.rentType?.[selectedLanguage]?.toLowerCase() ===
                                  'monthly' ? (
                                  <p className={classes.perMonth}> /{t('perMonth')}</p>
                                ) : (
                                  <p className={classes.perMonth}>/{t('perYear')}</p>
                                )
                              ) : (
                                ''
                              )}
                            </div>
                          </div>
                          <div>
                            <Tabs
                              className={classes.tab}
                              tabClass={classes.tab}
                              value={tabValue}
                              setValue={(e) => {
                                setTabValue(e);
                              }}
                              tabsData={tabsData}
                            />
                          </div>
                        </div>
                        <div className={classes.titleStyle}>
                          <p>{propertyData?.title?.[selectedLanguage]}</p>
                        </div>

                        <div className={classes.addressWrap}>
                          <MdLocationOn color="#00A997" size={21} />
                          <p>{propertyData?.address}</p>
                        </div>
                      </div>
                      {propertyData?.openHouseStartDate && (
                        <div className={classes.openHouseWrap}>
                          <p>{t('openHouse')}</p>
                          <div className="flex-align-center">
                            <MdOutlineDateRange size={13} color="var(--text-dark-gray-clr)" />

                            <span className={classes.dateTime}>
                              {moment(propertyData?.openHouseStartDate).format('DD/MM/YYYY')} to{' '}
                              {moment(propertyData?.openHouseEndDate).format('DD/MM/YYYY')}
                            </span>
                          </div>
                          <div className="flex-align-center">
                            <BiTimeFive size={13} color="var(--text-dark-gray-clr)" />
                            <span className={classes.dateTime}>
                              {moment(propertyData?.openHouseStartDate).format('hh:mm a')} to{' '}
                              {moment(propertyData?.openHouseEndDate).format('hh:mm a')}
                            </span>
                          </div>
                        </div>
                      )}
                    </div>
                    <div className={classes.propertyDetailWrap}>
                      <div className={classes.propertyDetail}>
                        <Tooltip text={t('tooltips.propertyType')}>
                          {/* <RiHotelFill color="var(--text-dark-gray-clr)" /> */}
                          <img src={building} alt="building" />
                        </Tooltip>
                        <p>{propertyData?.propertyType?.title?.[selectedLanguage]}</p>
                      </div>
                      <div className={classes.propertyDetail}>
                        <Tooltip text={t('tooltips.area') + ` (${areaUnit})`}>
                          <img src={Area} alt="building" />

                          {/* <BsGrid3X3Gap color="var(--text-dark-gray-clr)" /> */}
                        </Tooltip>

                        <p>
                          {m2ToFt2({
                            area: propertyData?.netArea,
                            areaUnit,
                            unit: true
                          })}
                        </p>
                      </div>
                      <div className={classes.propertyDetail}>
                        <Tooltip text={t('tooltips.rooms')}>
                          {/* <MdOutlineHotel color="var(--text-dark-gray-clr)" /> */}
                          <img src={Rooms} alt="building" />
                        </Tooltip>
                        <p>{propertyData?.noOfRooms?.[selectedLanguage]}</p>
                      </div>
                      <div className={classes.propertyDetail}>
                        <Tooltip text={t('tooltips.bathrooms')}>
                          {/* <MdOutlineBathtub color="var(--text-dark-gray-clr)" /> */}
                          <img src={Bath} alt="building" />
                        </Tooltip>
                        <p>{propertyData?.noOfBathrooms}</p>
                      </div>
                      <div className={classes.propertyDetail}>
                        <Tooltip text={t('tooltips.level')}>
                          {/* <FaLevelUpAlt color="var(--text-dark-gray-clr)" /> */}
                          <img src={Grounds} alt="building" />
                        </Tooltip>

                        <p>{propertyData?.floorLevel?.[selectedLanguage]}</p>
                      </div>

                      {/* </div> */}
                    </div>
                    <div className={classes.description}>
                      {/* <HeadingWithUnderline underlineColor="var(--secondary-clr)"> */}
                      {/* <h5>{t('description')}</h5> */}
                      {/* </HeadingWithUnderline> */}
                      {/* <ShowMoreShowLessText
                        text={parse(propertyData?.description?.[selectedLanguage] || '')}
                        visibility={300}
                        customClass={classes.showMoreStyle}></ShowMoreShowLessText> */}
                      <div className={classes.descriptionContent}>
                        {parse(propertyData?.description?.[selectedLanguage] || '')}
                      </div>
                    </div>
                  </div>
                  <div className={classes.firstRowLeftCol}>
                    <div className={classes.overView}>
                      {/* <HeadingWithUnderline underlineColor="var(--secondary-clr)"> */}
                      <h5>{t('overview.title')} </h5>
                      {/* </HeadingWithUnderline> */}
                      <Row className={classes.overViewRow}>
                        <Col lg={6} md={12}>
                          <ListItemWithCheckMark showCheck={false} mainClass={classes.list}>
                            <div className={`flex-sb ${classes.listItem}`}>
                              <span>{t('overview.listingID')}</span>
                              <span>{propertyData?.listingId}</span>
                            </div>
                          </ListItemWithCheckMark>
                        </Col>
                        <Col lg={6} md={12}>
                          {' '}
                          <ListItemWithCheckMark mainClass={classes.list} showCheck={false}>
                            <div className={`flex-sb ${classes.listItem}`}>
                              <span>{t('overview.type')}</span>
                              <span>{propertyData?.propertyType?.title?.[selectedLanguage]}</span>
                            </div>
                          </ListItemWithCheckMark>
                        </Col>
                        <Col lg={6} md={12}>
                          {' '}
                          {propertyData?.rentType && (
                            <ListItemWithCheckMark mainClass={classes.list} showCheck={false}>
                              <div className={`flex-sb ${classes.listItem}`}>
                                <span>{t('overview.rentType')}</span>
                                <span> {propertyData?.rentType?.[selectedLanguage]}</span>
                              </div>
                            </ListItemWithCheckMark>
                          )}
                        </Col>
                        <Col lg={6} md={12}>
                          {' '}
                          <ListItemWithCheckMark mainClass={classes.list} showCheck={false}>
                            <div className={`flex-sb ${classes.listItem}`}>
                              <span>
                                {propertyData?.propertyPurpose?.en == 'Rent'
                                  ? t('overview.rentPrice')
                                  : t('overview.price')}
                              </span>

                              <span>
                                {usdToOther({ amount: propertyData?.price, ...currency })}
                              </span>
                            </div>
                          </ListItemWithCheckMark>
                        </Col>
                        <Col lg={6} md={12}>
                          {' '}
                          <ListItemWithCheckMark mainClass={classes.list} showCheck={false}>
                            <div className={`flex-sb ${classes.listItem}`}>
                              <span>{t('overview.area')}</span>
                              <span>
                                {m2ToFt2({
                                  area: propertyData?.netArea,
                                  areaUnit
                                })}
                              </span>
                            </div>
                          </ListItemWithCheckMark>
                        </Col>
                        <Col lg={6} md={12}>
                          {' '}
                          <ListItemWithCheckMark mainClass={classes.list} showCheck={false}>
                            <div className={`flex-sb ${classes.listItem}`}>
                              <span>{t('overview.rooms')}</span>
                              <span> {propertyData?.noOfRooms?.[selectedLanguage]}</span>
                            </div>
                          </ListItemWithCheckMark>
                        </Col>
                        <Col lg={6} md={12}>
                          <ListItemWithCheckMark mainClass={classes.list} showCheck={false}>
                            <div className={`flex-sb ${classes.listItem}`}>
                              <span>{t('overview.bathrooms')}</span>
                              <span>{propertyData?.noOfBathrooms}</span>
                            </div>
                          </ListItemWithCheckMark>
                        </Col>
                        <Col lg={6} md={12}>
                          <ListItemWithCheckMark mainClass={classes.list} showCheck={false}>
                            <div className={`flex-sb ${classes.listItem}`}>
                              <span>{t('overview.propertyTitleDeed')}</span>
                              <span> {propertyData?.titleOfDeed?.[selectedLanguage]}</span>
                            </div>
                          </ListItemWithCheckMark>
                        </Col>
                        <Col lg={6} md={12}>
                          <ListItemWithCheckMark showCheck={false} mainClass={classes.list}>
                            <div className={`flex-sb ${classes.listItem}`}>
                              <span>{t('overview.parkingSpaces')}</span>
                              <span>{propertyData?.parkingSpace}</span>
                            </div>
                          </ListItemWithCheckMark>
                        </Col>
                        <Col lg={6} md={12}>
                          <ListItemWithCheckMark mainClass={classes.list} showCheck={false}>
                            <div className={`flex-sb ${classes.listItem}`}>
                              <span>{t('overview.furniture')}</span>
                              <span>{propertyData?.furniture?.[selectedLanguage]}</span>
                            </div>
                          </ListItemWithCheckMark>
                        </Col>
                        <Col lg={6} md={12}>
                          <ListItemWithCheckMark mainClass={classes.list} showCheck={false}>
                            <div className={`flex-sb ${classes.listItem}`}>
                              <span>{t('overview.floorLevel')}</span>
                              <span>{propertyData?.floorLevel?.[selectedLanguage]}</span>
                            </div>
                          </ListItemWithCheckMark>
                        </Col>
                        <Col lg={6} md={12}>
                          {' '}
                          <ListItemWithCheckMark mainClass={classes.list} showCheck={false}>
                            <div className={`flex-sb ${classes.listItem}`}>
                              <span>{t('overview.propertyAge')}</span>
                              <span>{propertyData?.propertyAge?.[selectedLanguage]}</span>
                            </div>
                          </ListItemWithCheckMark>
                        </Col>
                        <Col lg={6} md={12}>
                          <ListItemWithCheckMark mainClass={classes.list} showCheck={false}>
                            <div className={`flex-sb ${classes.listItem}`}>
                              <span>{t('overview.propertyStatus')}</span>
                              <span>{propertyData?.propertyStatus?.[selectedLanguage]}</span>
                            </div>
                          </ListItemWithCheckMark>
                        </Col>
                        <Col lg={6} md={12}>
                          <ListItemWithCheckMark mainClass={classes.list} showCheck={false}>
                            <div className={`flex-sb ${classes.listItem}`}>
                              <span>{t('overview.propertyOrientation')}</span>
                              <span>
                                {Array.isArray(propertyData?.propertyOrientation)
                                  ? propertyData?.propertyOrientation
                                    ?.map((item) => item?.[selectedLanguage])
                                    ?.join(', ')
                                  : propertyData?.propertyOrientation?.[selectedLanguage]}
                              </span>
                            </div>
                          </ListItemWithCheckMark>
                        </Col>
                      </Row>
                    </div>
                    <div className={classes.interior}>
                      {/* <HeadingWithUnderline underlineColor="var(--secondary-clr)"> */}
                      <h5>{t('amenities')}</h5>
                      {/* </HeadingWithUnderline> */}
                      <div className={classes.interior}>
                        {/* <HeadingWithUnderline> */}
                        <h6>{t('interiorAmenities')}</h6>
                        {/* </HeadingWithUnderline> */}
                        <Row className={classes.interior}>
                          {propertyData?.interiorAmenities?.map((item, index) => (
                            <Col md={6} key={`${item?._id}-${index}`}>
                              <ListItemWithCheckMark mainClass="flex-align-center">
                                <div className={`${classes.interiorList}`}>
                                  <span>{item?.title?.[selectedLanguage]}</span>
                                </div>
                              </ListItemWithCheckMark>
                            </Col>
                          ))}
                        </Row>
                      </div>
                      <div className={classes.interior}>
                        {/* <HeadingWithUnderline> */}
                        <h6>{t('exteriorAmenities')}</h6>
                        {/* </HeadingWithUnderline> */}
                        <Row className={classes.interior}>
                          {propertyData?.exteriorAmenities?.map((item, index) => (
                            <Col md={4} key={`${item?._id}-${index}`}>
                              <ListItemWithCheckMark mainClass="flex-align-center">
                                <div className={`${classes.interiorList}`}>
                                  <span>{item?.title?.[selectedLanguage]}</span>
                                </div>
                              </ListItemWithCheckMark>
                            </Col>
                          ))}
                        </Row>
                      </div>
                    </div>
                  </div>

                  <div className={[classes.firstRowLeftCol].join(' ')}>
                    <AverageRatesWithMarketTrends
                      t={t}
                      title={t('marketTrends')}
                      subTitle={t('averageSale')}
                      BarChartTile={t('chartHeader')}
                      BarChartTile2={t('chartHeader2')}
                      neighborhoodId={propertyData?.neighborhood?._id}
                    />
                  </div>
                  <div className={classes.firstRowLeftCol}>
                    <MortgageCalculator heading={t('mortgage.title')} />
                  </div>
                </div>
              </Col>

              {/* Right column */}
              <Col md={12} lg={3} className={classes.col2}>
                <div className={classes.clientCard}>
                  <ClientManagerCard
                    pageData={propertiesData[0]}
                    dataType={'property'}
                    data={propertyData}
                  />
                </div>
                {thisPageBanners?.find((b) => b?.bannerType === 'vertical') && (
                  <div className={classes?.bannerAdContainer}>
                    <BannerImageAd
                      image={imageUrl(
                        thisPageBanners?.find((b) => b?.bannerType === 'vertical')?.image
                      )}
                      link={thisPageBanners?.find((b) => b?.bannerType === 'vertical')?.link}
                      className={classes.verticalBanner}
                    />
                  </div>
                )}
              </Col>
            </Row>
          </Container>
          <BankLoanBanner t={t} />
          <Container>
            {thisPageBanners?.find((b) => b?.bannerType === 'horizontal') && (
              <div className={classes?.bannerAdContainer}>
                <BannerImageAd
                  image={imageUrl(
                    thisPageBanners?.find((b) => b?.bannerType === 'horizontal')?.image
                  )}
                  link={thisPageBanners?.find((b) => b?.bannerType === 'horizontal')?.link}
                  className={classes.horizontalBanner}
                />
              </div>
            )}
          </Container>
          {reportShow && (
            <ReportListingModal
              show={reportShow}
              setShow={setReportShow}
              entity={propertyData?._id}
            />
          )}
          {isShareModalOpen && (
            <ShareModal
              selectedLanguage={selectedLanguage}
              show={isShareModalOpen}
              setShow={setIsShareModalOpen}
            />
          )}
        </div>
      )}
      <Footer showDownload={false} />
    </>
  );
};

export default PropertyDetails;


